import { Flex, RemoteImage, Typography } from '@banhala/ui-kit';
import { useAtomValue } from 'jotai';
import { useEffect, useMemo, useState } from 'react';
import { Image as RNImage } from 'react-native';
import { useMyPersonalizationSizeAtoms } from '../../state';

const IMAGE_WIDTH = 340;

export const MeasureSpotsImage = () => {
  const [imageHeight, setImageHeight] = useState<number | null>(null);

  const { selectedProductCategoryAtom } = useMyPersonalizationSizeAtoms();
  const selectedProductCategory = useAtomValue(selectedProductCategoryAtom);

  const normalizedSpots = useMemo(() => {
    if (imageHeight == null) return [];
    return selectedProductCategory.measure_spots.map(spot => {
      return {
        ...spot,
        bottom:
          ((-((spot.position + 1) * 12) + Math.abs(spot.top)) / imageHeight) *
          100,
        left: (spot.left / IMAGE_WIDTH) * 100,
      };
    });
  }, [imageHeight, selectedProductCategory.measure_spots]);

  useEffect(() => {
    let isCancelled = false;

    RNImage.getSize(
      selectedProductCategory.image_placeholder,
      (width, height) => {
        if (isCancelled || height === 0) {
          return;
        }

        setImageHeight((height * ((IMAGE_WIDTH / width) * 100)) / 100);
      },
      () => {
        if (!isCancelled) {
          setImageHeight(0);
        }
      },
    );

    return () => {
      isCancelled = true;
    };
  }, [selectedProductCategory.image_placeholder]);

  return (
    <Flex alignItems="center" justifyContent="center">
      {imageHeight ? (
        <Flex position="relative" width={IMAGE_WIDTH} height={imageHeight}>
          <RemoteImage
            uri={selectedProductCategory.image_placeholder}
            width={IMAGE_WIDTH}
            height={imageHeight}
            resizeMode="cover"
          />
          {normalizedSpots.map(spot => (
            <Flex
              key={spot.sno}
              position="absolute"
              width="100%"
              bottom={`${spot.bottom}%`}
              left={`${spot.left}%`}
            >
              <Typography
                type="subtitle5"
                color="content_primary"
                textAlign="center"
              >
                {spot.name}
              </Typography>
            </Flex>
          ))}
        </Flex>
      ) : (
        <Flex width={IMAGE_WIDTH} height={350} />
      )}
    </Flex>
  );
};
